<template>
  <NhapMaKichHoatOtp />
</template>

<script>
import NhapMaKichHoatOtp from "@/components/pages/quan-tri-he-thong/NhapMaKichHoatOtp.vue";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";

// Phase 7C UC11: wrapper route màn user nhập mã kích hoạt.
export default {
  name: "TrangNhapMaKichHoat",
  components: {
    NhapMaKichHoatOtp,
  },
  created() {
    setBreadcrumb(`${MENU_ROUTE_NAME.NHAP_MA_KICH_HOAT}`);
  },
};
</script>
